import React, { useContext, useEffect, useState } from "react";
import { ApiContext, FetchContext } from ".";

export const DataContext = React.createContext(null);

const { Provider } = DataContext;
export const DataProvider = ({ ...props }) => {
    // providers
    const {
        user,
    } = useContext(FetchContext);
    const {
        getUtentiAsync,
        getImpostazioneAsync,
    } = useContext(ApiContext);


    const [isInitialLoading, setIsInitialLoading] = useState(false);
    const [utenti, setUtenti] = useState(null);
    const [impostazione, setImpostazione] = useState(null);

    const initializeData = async () => {
        setIsInitialLoading(true);
        const utentiResponse = await getUtentiAsync();
        utentiResponse?.data && setUtenti(utentiResponse.data.result);
        const impostazioneResponse = await getImpostazioneAsync();
        impostazioneResponse?.data && setImpostazione(impostazioneResponse.data);
        setIsInitialLoading(false);
    }

    useEffect(() => {
        user && initializeData();
    }, [user]);

    return (
        <Provider value={{
            isInitialLoading,
            utenti,
            impostazione,
        }}>
            {props.children}
        </Provider>
    );
}